<template>
  <div class="echartPage">
    <div class="headerClass">{{ tagId }}</div>
    <div class="contentClass">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        @resetFn="resetFn"
        @searchFn="searchFn"
        :inline="true"
        :optareBtn="optareBtn"
      />
      <!-- tab -->
      <TabEchart @unitChange="unitChange" @downLoad="downLoad" :tabs="tabs"/>
      <!-- 信息 -->
      <InfoMsg :listObj="listObj" />
      <div v-show="echartObj.data.length">
        <!-- 图表 -->
        <EchartContent
          ref="chart"
          :echartObj="echartObj"
          :loading="chartLoading"
          :unitObj="unitObj"
          :options="chartOptions"
        />
        <!-- 最值 -->
        <!-- 门磁没有最大值最小值，不显示 -->
        <MaxMin v-show="this.SearchForm.probe !== 'magnetism'" :listObj="listObj" :unitObj="unitObj" />
        <!-- 表格 -->
        <dataTable
          :loading="loading"
          :tableData="tableData"
          :unitObj="unitObj"
        />
        <!-- 分页 -->
        <!--                <Pagination ref='pagination' class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"-->
        <!--                    :limit.sync="SearchForm.iDisplayLength" :iDisplayLength="5" @pagination="getListFn('async')"-->
        <!--                    :pageSizes="pageSizes">-->
        <!--                </Pagination>-->

        <Pager
          ref="pagination"
          :total="total"
          :size="SearchForm.iDisplayLength"
          @currentChange="currentChange"
        ></Pager>
      </div>
      <div v-show="!echartObj.data.length">
        <el-empty></el-empty>
      </div>
    </div>
    <exportDialog
      :isShow.sync="exportDiaShow"
      :searchForm="eForm"
      ref="dia"
      :comNmae="shareExportHistory"
    />
  </div>
</template>

<script>
import { shareExportHistory, shareHistory } from '@/api/modules/public.js'
import mixinForm from '@/utils/formMixins.js'
import exportDialog from '../../../count/component/exportDialog.vue'
import TabEchart from './EchartTab.vue'
import InfoMsg from './InfoMsg.vue'
import EchartContent from './EchartContent.vue'
import MaxMin from './MaxMin.vue'
import dataTable from './DataTable.vue'
import store from '@/store'
import { downloadImage } from '@/utils/file/download'
import Pager from '@/components/Pagination/src/Pager.vue'
import chartOptions from '@/config/chart/chartOptions'

export default {
  mixins: [mixinForm],
  components: {
    Pager,
    TabEchart,
    InfoMsg,
    EchartContent,
    MaxMin,
    dataTable,
    exportDialog
  },
  data () {
    return {
      chartOptions: chartOptions(),
      tagId: '',
      // ----------------------
      formContent: [
        {
          id: 1,
          text: 'public.time',
          type: 'datetimerange',
          paramsName: 'time',
          isChooze: true
        },
        {
          id: 2,
          text: 'integration.abnormal',
          type: 'select',
          paramsName: 'isEx',
          selectParam: [
            {
              id: 1,
              icon: '',
              value: '',
              label: 'public.please'
            },
            {
              id: 2,
              icon: '',
              value: 0,
              label: this.$t('public.btn_no')
            },
            {
              id: 3,
              icon: '',
              value: 1,
              label: $t('public.btn_yes')
            }
          ],
          isChooze: false
        },
        {
          id: 3,
          text: $t('integration.storage'),
          type: 'select',
          paramsName: 'isStore',
          selectParam: [
            {
              id: 1,
              icon: '',
              value: '',
              label: 'public.please'
            },
            {
              id: 2,
              icon: '',
              value: 0,
              label: this.$t('public.btn_no')
            },
            {
              id: 3,
              icon: '',
              value: 1,
              label: $t('public.btn_yes')
            }
          ],
          isChooze: false
        }
      ],
      chartLoading: false,
      optareBtn: [],
      SearchForm: {
        no: '',
        time: '',
        isEx: '',
        isStore: '',
        dataSort: 0,
        pageSort: 1,
        devCatalog: 0,
        block: 1,
        probe: 'temp',
        token: null,
        iDisplayStart: 0,
        iDisplayLength: 5
      },
      listObj: {},
      // echart 数据  必须分离 否则 造成页面渲染缓慢以及卡顿
      echartObj: {
        min: '',
        max: '',
        data: [],
        rangeData: []
      },
      pageSizes: [5, 20, 50, 100],
      tableData: [],
      total: 0,
      // 温度
      unitArray: [
        {
          key: 'temp',
          unit: "store.state.unit['temp'].name",
          yText: `${$t('public.temp')}(${"store.state.unit['temp'].name"})`
        },
        {
          key: 'hum',
          unit: "store.state.unit['hum'].name",
          yText: `${$t('public.hum')}(${"store.state.unit['hum'].name"})`
        },
        {
          key: 'volt',
          unit: $t('integration.volts'),
          yText: 'volt(V)'
        },
        {
          key: 'rssi',
          unit: 'dBm',
          yText: 'rssi(dBm)'
        },
        {
          key: 'lqi',
          unit: '',
          yText: 'lqi'
        },
        // 增加气体和门磁单位
        {
          key: 'gas',
          unit: '%LEL',
          yText: `${$t('route.gas')}(%LEL)`
        },
        {
          key: 'magnetism',
          unit: '',
          yText: `${$t('route.magnetism')}`
        },
        {
          key: 'coz',
          unit: '%vol',
          yText: `coz(%vol)`
        },
        //
      ],
      unitObj: {},
      exportDiaShow: false,
      eForm: {},
      shareExportHistory,
      timeoutFlag: 0,

      // 默认传感器有的tab
      tabs: ['temp', 'hum', 'volt', 'rssi', 'lqi']
      //
    }
  },
  created () {
    this.tagId = this.$route.query.tagId
    // 气体和门磁需要修改devCatalog和probe参数
    if(this.$route.query.devCatalog){
      this.SearchForm.devCatalog = parseInt(this.$route.query.devCatalog)
      // 气体和门磁没有温度/湿度tab
      this.tabs = [this.$route.query.probe, 'volt', 'rssi', 'lqi']
    }
    if(this.$route.query.probe){
      this.SearchForm.probe = this.$route.query.probe
    }
  },
  methods: {
    currentChange ({ iDisplayStart, iDisplayLength }) {
      this.SearchForm.iDisplayStart = iDisplayStart
      this.SearchForm.iDisplayLength = iDisplayLength

      this.getListFn()
    },
    downLoad () {
      // const { no, time } = this.SearchForm
      // if (time.length === 0) return this.$message.warning($t('integration.time_cannot_be_empty'))
      // this.eForm = {
      //   no,
      //   startTime: this.$dateParseTime(time[0]),
      //   endTime: this.$dateParseTime(time[1])
      // }
      //
      // this.exportDiaShow = true
      // this.$nextTick(() => {
      //   this.$refs.dia.initForm()
      // })
      const { no, time } = this.SearchForm
      const base64 = this.$refs.chart.getChart()
      downloadImage(
        base64,
        `[${no}]_${$t('integration.device_historical_line_chart')}_F[${time[0]}]_T[${time[1]}]`
      )
    },
    resetFn () {
      this.SearchForm.time = ''
      this.SearchForm.isEx = ''
      this.SearchForm.isStore = ''
      this.SearchForm.iDisplayStart = 0
      this.SearchForm.iDisplayLength = 5
      this.$refs.pagination.reset()
      this.getListFn('sync')
    },
    /**
     * 计算两个时间是否大于10days
     * @param {String} starDate 进行比较的开始日期 时间戳 毫秒
     * @param {String} endDate 进行比较的结束日期  时间戳 毫秒
     * @returns {Boolean}
     */
    getD (starDate, endDate) {
      // 默认10天
      var thisMothDays = 1000 * 3600 * 24 * 10
      if (endDate - starDate > thisMothDays) {
        return true
      } else {
        return false
      }
    },
    searchFn () {
      this.SearchForm.iDisplayStart = 0
      this.$refs.pagination.reset()

      this.getListFn('search')
    },
    getListFn (Async) {
      console.log('-getListFn----')
      // pagination emit是没有这个参数的
      if (!Async && this.$route.query.probe) {
        this.SearchForm.probe = this.$route.query.probe
      }

      this.loading = true
      this.SearchForm.no = this.tagId
      clearTimeout(this.timeoutFlag)
      const query = { ...this.SearchForm }
      if (query.time && query.time.length > 0) {
        query.from = this.$dateParseTime(query.time[0])
        query.to = this.$dateParseTime(query.time[1])
        const flag = this.getD(
          this.$dateParseTime(query.time[0]),
          this.$dateParseTime(query.time[1])
        )
        if (flag) {
          query.block = 0
        } else {
          query.block = 1
        }
        if (Async === 'search') {
          this.chartLoading = true
          // 当条件不相等时才会清除token
          query.token = null
        }
      }
      delete query.time
      shareHistory(query)
        .then(({ result }) => {
          if (result && result.ok === 1) {
            const { page } = result
            this.tableData = page.result || []
            this.total = page.pageInfo.total
            // 这里是为了echart 的数据量过大时候的操作 抽离echart的数据
            if (
              query.block === 0 ||
              (this.echartObj.data && this.echartObj.data.length === 0)
            ) {
              this.echartObj = {
                max: result.max,
                min: result.min,
                data: result.data,
                rangeData: result.rangeData || []
              }
            }
            // // 搜索时候重新赋值
            if (Async === 'search') {
              this.echartObj = {
                max: result.max,
                min: result.min,
                data: result.data,
                rangeData: result.rangeData || []
              }
            }
            this.loading = false
            this.chartLoading = false
            result.data = []
            this.listObj = result
            this.SearchForm.time = [
              this.$timetransition(result.dafaultForm),
              this.$timetransition(result.dafaultTo)
            ]
            if (result.token) {
              this.SearchForm.token = result.token
            }
          } else {
            // 兼容一下吧，如果出现result: {}的情况就不轮询了
            if(result.ok === undefined){
              return
            }
            // 不断轮询请求
            this.timeoutFlag = setTimeout(() => {
              this.SearchForm.token = result.token
              this.getListFn()
            }, 1000)
          }
        })
        .catch(() => {
          this.tableData = []
          this.total = 0
          this.listObj = {}
        })
        .finally(() => {
          // this.loading = false;
        })
    },
    unitChange (name) {
      this.unitArray.forEach(item => {
        if (name === item.key) {
          this.unitObj = item
        }
      })
      this.SearchForm.probe = name
      // this.token = null;
      this.count = 0
      this.getListFn('search')
    },
    updateUnit () {
      this.unitArray[0] = {
        key: 'temp',
        unit: store.state.unit.temp.name,
        yText: `${$t('public.temp')}(${store.state.unit.temp.name})`
      }
      this.unitArray[1] = {
        key: 'hum',
        unit: store.state.unit.hum.name,
        yText: `${$t('public.hum')}(${store.state.unit.hum.name})`
      }
      if (!Object.keys(this.unitObj).length) {
        const { probe } = this.$route.query
        if (probe) {
          const item = this.unitArray.find(item => item.key === probe)
          this.unitObj = item
        } else {
          this.unitObj = this.unitArray[0]
        }
      }
    }
  },
  mounted () {
    store.dispatch('unit').then(res => {
      this.updateUnit()
    })
    this.chartOptions.title.subtext = this.$route.query.description
  }
}
</script>

<style lang="scss" scoped>
.echartPage {
  height: 100%;
  padding: 15px;
  padding-top: 0;
  box-sizing: border-box;

  .headerClass {
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #ccc;
    box-sizing: border-box;
    // margin-bottom: 15px;
  }

  .contentClass {
    width: 100%;
    height: calc(100% - 55px);
  }

  ::v-deep .el-tabs__header {
    margin-bottom: 10px;
  }
}
</style>
